(function() {
    angular
        .module("app", [
            "loginModule",
            "devicesModule",
            "apiModule",
            "usersModule",
            "customersModule",
            "alertsModule",
            "noticesModule",
            "feedbackModule",
            "globalSearchModule",
            "globalArrowBoardMapModule",
            "wzModule",
            "ui.router",
            "ngCookies",
            "ngAnimate",
            "angular.filter",
            "ui.bootstrap",
            "ui.mask",
            "datatables",
            "ngFileSaver",
            "rzSlider"
        ]
    )
})()
